import Profile from './profile.vue';
import Heading from './heading.vue';
import Default from './default.vue';

export default {
	// Normal fields
	"profile": Profile,
	"heading": Heading,
	"default": Default
};